import React from 'react';

const UserIdContext = React.createContext({});

export default UserIdContext;
